<template>
  <v-list>
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title>{{
          usuarioLogado ? usuarioLogado.nome : "Olá, usuário"
        }}</v-list-item-title>
        <v-list-item-subtitle>{{
          usuarioLogado ? usuarioLogado.usuario : ""
        }}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action v-if="usuarioLogado">
        <v-btn icon color="secondary" to="/config-conta"
          ><v-icon>mdi-account-cog-outline</v-icon></v-btn
        >
      </v-list-item-action>
    </v-list-item>
    <v-list-item v-if="usuarioLogado">
      <v-list-item-content>
        <TrocarUsuario />
      </v-list-item-content>
      <v-list-item-action>
        <SairSistema />
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapState } from "vuex";
import SairSistema from "./SairSistema.vue";
import TrocarUsuario from "./TrocarUsuario.vue";

export default {
  components: {
    SairSistema,
    TrocarUsuario,
  },
  computed: mapState("usuario", ["usuarioLogado"]),
  data: () => ({
    loading: true,
  }),
};
</script>

<style>
</style>